var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveygeneralstart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4454 6.12401L4.912 0.620117C2.91989 -0.53034 0.430176 0.907101 0.430176 3.20801V14.2158C0.430176 16.5167 2.91989 17.9542 4.912 16.8037L14.4454 11.2998C16.4375 10.1493 16.4375 7.27447 14.4454 6.12401Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveygeneralstart);
export default __webpack_public_path__ + "static/media/surveygeneralstart.5399d82504b96bd8d5c5b2bc0c696377.svg";
export { ForwardRef as ReactComponent };